/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CountryDto
 */
export interface CountryDto {
    /**
     * 
     * @type {number}
     * @memberof CountryDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CountryDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CountryDto
     */
    name?: string | null;
}

/**
 * Check if a given object implements the CountryDto interface.
 */
export function instanceOfCountryDto(value: object): value is CountryDto {
    return true;
}

export function CountryDtoFromJSON(json: any): CountryDto {
    return CountryDtoFromJSONTyped(json, false);
}

export function CountryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function CountryDtoToJSON(json: any): CountryDto {
    return CountryDtoToJSONTyped(json, false);
}

export function CountryDtoToJSONTyped(value?: CountryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'name': value['name'],
    };
}

